/**
 * Formats a hotel price amount with the given currency code for display.
 * Returns undefined when the amount is not a finite positive number
 * so callers can show a translated "rate unavailable" label instead.
 */
export function formatHotelPrice(
  amount: number,
  currency: string,
  locale = 'es',
): string | undefined {
  if (!Number.isFinite(amount) || amount <= 0) return undefined;
  const formatted = new Intl.NumberFormat(locale).format(amount);
  return `${currency} ${formatted}`;
}
